export class ChangeShowProgressbar {
   public static readonly type = '[PresenceDurationBrickSettings] Change Show Progressbar';

   constructor(public brickInstanceId, public show: boolean) {}
}

export class ChangeShowDurationAsText {
   public static readonly type = '[PresenceDurationBrickSettings] Change Show Text';

   constructor(public brickInstanceId, public show: boolean) {}
}
